var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{staticClass:"ModalLogin modal-login is--small",attrs:{"value":_vm.value,"size":"small"},on:{"close":_vm.onCancel}},[_c('h3',{staticClass:"modal-login__title"},[_vm._v("Log In")]),_c('FormLogin',{staticClass:"modal-login__form",attrs:{"on-sign-up-redirect":_vm.onSignUpRedirect},on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }